import { memo } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { BzChip, BzDatePicker, BzDropdown, BzInputText } from '../../../components';



const Lumpsum = ({ fund, data }) => {

    const renderSelect = ({ label, name, options }) => {
        return (
            <Col md={2} className='me-3 mb-3'>
                <div className='font-regular font-size2 color-subtext mb-1'>{label}</div>
                <div className='Bzmodalselect-dropdown'>
                    <BzDropdown size="sm">
                        <Dropdown.Toggle className='btn-default'>{options?.[0]}</Dropdown.Toggle>
                        <Dropdown.Menu>
                            {options?.map((eachOption, i) => (
                                <Dropdown.Item key={i} value={eachOption}>{eachOption}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </BzDropdown>
                </div>
            </Col>
        );
    };


    const renderInputCounter = ({ label, name, state, onAddition, onSubtraction, onCounterChange, options, message }) => {
        return (
            <Col md={3} className='me-3 mb-3'>
                <div className='d-flex align-items-center mb-1'>
                    <div className='font-regular font-size2 color-subtext'>{label}</div>
                    <div className='icon-10 icon-arrowdown icon-dark ms-2'></div>
                </div>                
                <div className='input-group postion-relative'>
                    <div onClick={onSubtraction} className='icon-12 icon-order-decrease input-number-left-wrap'></div>
                    <BzInputText type="number" className='text-center p-0 font-regular' placeholder='1' name={name} onChange={(e) => onCounterChange(e)} value={state} />
                    <div onClick={onAddition} className='icon-12 icon-order-increase input-number-right-wrap'></div>
                </div>                
                {message ? <div className='d-flex justify-content-start align-items-center pt-2'>
                    <div className='icon-16 icon-info icon-dark'>&nbsp;</div>
                    <div className='font-regular font-size1 color-subtext ms-2'>{message}</div>
                </div> : null}
            </Col>
        );
    };

    const renderDate = ({ dateLabel, checkBoxLabel }) => {
        return (
            <Col md={3} className='me-3 mb-3'>
                <div className='font-regular font-size2 color-subtext mb-1'>{dateLabel}</div>
                <div className='datepicker-wrap'>
                    <BzDatePicker className='form-datepicker-primary form-control font-regular py-1 px-2' />
                </div>
                <div className='d-flex justify-content-start align-items-center pt-2'>
                    <input type='checkbox' className='form-check-input' />
                    <div className='font-regular font-size1 color-subtext ms-2'>{checkBoxLabel}</div>
                </div>
            </Col>
        );
    };

    return (
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col md={9} className='d-flex justify-content-start'>
                    <Row className='g-0'>
                        <Col className='flex-column'>
                            <div className='d-flex'>
                                <div className='font-medium font-size5 color-text pe-3'>{fund?.fundName}</div>
                                <div className='chips-wrap flex-wrap m-1'>
                                    {fund?.category?.map((categoryName, index) => <BzChip key={index} className='chips primary-chip text-uppercase me-2'>{categoryName}</BzChip>)}
                                </div>
                            </div>
                            <div className='d-flex align-items-center pt-1'>
                                <div className='font-regular font-size1 color-subtext pe-1'>You currently hold</div>
                                <div className='font-regular font-size1 color-text pe-1'>{fund?.unit} units</div>
                                <div className='font-regular font-size1 color-subtext pe-1'>worth of </div>
                                <div className='font-regular font-size1 color-text'>&#8377;{fund?.minAmount}</div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col md={3}>
                    <Row className='g-0'>
                        <Col className='d-flex align-items-center justify-content-end'>
                            <div className='font-regular font-size4 color-subtext'>NAV:</div>
                            <div className='font-regular font-size4 color-text ms-1'>&#8377;{fund?.nav}</div>
                            <div className='icon-16 icon-info icon-dark ms-1'></div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-1'>
                        <Col className='d-flex align-items-center justify-content-end'>
                            <div className='font-regular font-size1 color-subtext'>NAV as on 14 Jul 21</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='g-0 mt-4'>
                {data?.map(field =>
                    field.type === 'counter' ?
                        renderInputCounter(field)
                        :
                        field.type === 'select' ?
                            renderSelect(field) : renderDate(field)
                )}
            </Row>
        </Container >
    );
};
export default memo(Lumpsum);